import { AppBootstrapModule } from './app-bootstrap/app-bootstrap.module';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthGuard } from './_guards';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { ComponentesModule } from './_componentes';
import { AppRoutingModule } from './app-routing.module';
import { AuthenticationService } from './_services';
import { LoginComponent } from './login/login.component';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { InicioComponent } from './inicio';
import { EmpresaComponent } from './empresa';
import { SubastasComponent } from './subastas';
import { ComoFuncionaComponent } from './como-funciona';
import { SubastasDetalleComponent } from './subastas-detalle';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CountdownTimerModule } from 'ngx-countdown-timer';
import { CondicionesSubastaComponent } from './condiciones-subasta';
import { ResumenPreciosComponent } from './resumen-precios';
import { ContactoComponent } from './contacto/contacto.component';
import { RegistroComponent } from './registro/registro.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BotDetectCaptchaModule } from 'angular-captcha';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { RecuperaContrasenaComponent } from './recupera-contrasena/recupera-contrasena.component';
import { LightboxModule } from 'ngx-lightbox';
import { GtagModule } from 'angular-gtag';
import { PropiedadesRuralesComponent } from './propiedades-rurales/propiedades-rurales.component';
import { PropiedadesRuralesDetalleComponent } from './propiedades-rurales-detalle/propiedades-rurales-detalle.component';
import { CambiarContrasenaComponent } from './cambiar-contrasena';
import { OwlModule } from 'ngx-owl-carousel';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    InicioComponent,
    EmpresaComponent,
    SubastasComponent,
    ComoFuncionaComponent,
    SubastasDetalleComponent,
    CondicionesSubastaComponent,
    ResumenPreciosComponent,
    ContactoComponent,
    RegistroComponent,
    RecuperaContrasenaComponent,
    PropiedadesRuralesComponent,
    PropiedadesRuralesDetalleComponent,
    CambiarContrasenaComponent,
  ],
  imports: [
    BrowserModule,
    AppBootstrapModule,
    ComponentesModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppBootstrapModule,
    CountdownTimerModule.forRoot(),
    AlertModule.forRoot(),
    ServiceWorkerModule.register('sw-master.js', {
      enabled: environment.production,
    }),
    BotDetectCaptchaModule.forRoot({
      captchaEndpoint: environment.baseUrl + '/simple-captcha-handler',
    }),
    NgMultiSelectDropDownModule.forRoot(),
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBJz5Z8wuo98c4SvYOWAuKNNsNGOGe4PLs',
    }),
    LightboxModule,
    GtagModule.forRoot({ trackingId: 'UA-101181654-2', trackPageviews: true }),
    OwlModule,
  ],
  providers: [
    AuthGuard,
    AuthenticationService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: 'googleTagManagerId', useValue: 'GTM-N3CN9VN' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
